import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { parse } from 'qs';

import { compose } from 'ramda';
import { resetPassword } from '../../actions/account';
import {
  getUser, getBalance,
} from '../../actions/user';
import ScreenFeedback from '../ScreenFeedback';
import ChangePasswordForm from '../ChangePasswordForm';
import SheetTitle from '../SheetTitle';

import c from './ResetPassword.less';

class ResetPasswordContainer extends Component {
  static propTypes = {
    resetPassword: PropTypes.func.isRequired,
    getUser: PropTypes.func.isRequired,
    getBalance: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    validToken: PropTypes.bool.isRequired,
  };

  state = {
    showForm: true,
    showSuccessMessage: false,
  };

  handleSubmit = (values) => {
    const { location: { search } } = this.props;
    const { token } = parse(search.slice(1));

    return this.props.resetPassword(values, token)
      .then(() => {
        this.setState({
          showForm: false,
          showSuccessMessage: true,
        });

        this.props.getUser();
        this.props.getBalance();
      });
  };

  render() {
    const { showForm, showSuccessMessage } = this.state;
    const { validToken } = this.props;

    return (
      <div className={c.container}>
        <SheetTitle title="Reset password" />
        {
          !validToken ? (
            <ScreenFeedback
              title="Reset password link is invalid or already expired"
              helpText={<Link to="/shop/reset-password" className={c.okButton}>Request new password</Link>}
              type="error"
            />
          ) : (
            <div className={c.wrapper}>
              {showForm && (
                <ChangePasswordForm
                  showCurrent={false}
                  onSubmit={this.handleSubmit}
                />
              )}
              {showSuccessMessage && (
                <ScreenFeedback
                  title="You have successfully changed password."
                  helpText={<Link to={'/'} className={c.okButton}>Ok</Link>}
                  type="success"
                />
              )}
            </div>
          )
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  validToken: state.validToken.isValid,
});

const mapDispatchToProps = {
  resetPassword,
  getUser,
  getBalance,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(ResetPasswordContainer);
